export class SearchModels{
    public search_field?:string
    public search_value?:string
}